import { render, staticRenderFns } from "./AccessMoreStrategiesFinancialHabits.vue?vue&type=template&id=4b045934&scoped=true&"
import script from "./AccessMoreStrategiesFinancialHabits.vue?vue&type=script&lang=ts&"
export * from "./AccessMoreStrategiesFinancialHabits.vue?vue&type=script&lang=ts&"
import style0 from "./AccessMoreStrategiesFinancialHabits.vue?vue&type=style&index=0&id=4b045934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b045934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VForm,VRadio,VRadioGroup,VRow,VTextField})
